import SalarieStatutHandicap from '@/generated/controls/salarie/SalarieStatutHandicap.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieStatutHandicap
})
